import { Navigate } from 'react-router';

import { Loader } from '@trendiolive/trendio-selfcare-ui-kit';

import useSession from 'hooks/useSession';

import { GuardProps } from 'model/types/auth';

import { APP_DEFAULT_PATH } from 'constants/appConstants';

export default function InitGuard({ children }: Readonly<GuardProps>) {
  const { status } = useSession();

  switch (status) {
    case 'booting':
    case 'attaching':
      return <Loader />;
    case 'anonymous':
      return <Navigate to="/login" replace />;
    case 'merchant-selection':
      return children;
    case 'active':
      return <Navigate to={APP_DEFAULT_PATH} replace />;
  }
}
